<form class="form-horizontal">
	<div class="OptionsGrid">
		<label *ngIf="lstSchool?.length > 1" class="NoMargin">Sort by</label>

		<select
			[disabled]="IsLoading() == true"
			*ngIf="lstSchool?.length > 1"
			class="form-control"
			(ngModelChange)="onSortByChanged($event)"
			name="SortBy"
			[(ngModel)]="filterOptions.SortByID"
		>
			<option value="" style="display: none"></option>
			<option *ngFor="let c of lstSortBy" [ngValue]="c.SortByID">
				{{ c.SortByDesc }}
			</option>
		</select>

		<label *ngIf="lstSchool?.length > 1" class="NoMargin">School</label>

		<select
			[disabled]="IsLoading() == true"
			*ngIf="lstSchool?.length > 1"
			class="form-control"
			(ngModelChange)="onSchoolChanged($event)"
			name="SchoolID"
			[(ngModel)]="filterOptions.SchoolID"
		>
			<option value="" style="display: none"></option>
			<option *ngFor="let c of lstSchool" [ngValue]="c.SchoolID">
				{{ c.SchoolFullName }}
			</option>
		</select>

		<label class="NoMargin">Status</label>

		<select
			[disabled]="IsLoading() == true"
			class="form-control"
			(ngModelChange)="onStatusChanged($event)"
			name="StatusID"
			[(ngModel)]="filterOptions.StatusID"
		>
			<option value="" style="display: none"></option>
			<option *ngFor="let c of lstStatus" [ngValue]="c.StatusID">
				{{ c.StatusDesc }}
			</option>
		</select>

		<label *ngIf="filterOptions.SchoolID > 0" class="NoMargin">Group</label>

		<select
			[disabled]="IsLoading() == true"
			*ngIf="filterOptions.SchoolID > 0"
			class="form-control"
			(ngModelChange)="onDynamicGroupChange($event)"
			name="DynamicGroupID"
			[(ngModel)]="filterOptions.DynamicGroup.DynamicGroupID"
		>
			<option value="" style="display: none"></option>
			<option *ngFor="let c of lstDynamicGroup" [ngValue]="c.DynamicGroupID">
				{{ c.DynamicGroupDesc }}
			</option>
		</select>

		<label *ngIf="HideGroupValue == 0" class="NoMargin">Value</label>

		<select
			[disabled]="IsLoading() == true"
			*ngIf="HideGroupValue == 0"
			class="form-control"
			(ngModelChange)="onDynamicGroupValueChange($event)"
			name="DynamicGroupValueID"
			[(ngModel)]="filterOptions.DynamicGroupValueID"
		>
			<option value="" style="display: none"></option>
			<option *ngFor="let c of lstDynamicGroupValue" [ngValue]="c.DynamicGroupValueID">
				{{ c.DynamicGroupValueDesc }}
			</option>
		</select>

		<label *ngIf="IsSBM == true">SBM Role</label>
		<select
			[disabled]="IsLoading() == true"
			*ngIf="IsSBM == true"
			class="form-control"
			(ngModelChange)="onWorkflowRoleChange($event)"
			name="WorkflowRoleID"
			[(ngModel)]="filterOptions.WorkflowRoleID"
		>
			<option value="" style="display: none"></option>
			<option *ngFor="let c of lstWorkflowRole" [ngValue]="c.WorkflowRoleID">
				{{ c.WorkflowRoleDesc }}
			</option>
		</select>

		<label class="NoMargin">Criteria</label>

		<div class="SearchGrid">
			<input
				[disabled]="IsLoading() == true"
				type="text"
				name="SearchValue"
				[(ngModel)]="filterOptions.Criteria"
				(keyup.enter)="filterChanged()"
				class="form-control"
			/>

			<button [disabled]="IsLoading() == true" type="button" (click)="filterChanged()" class="btn btn-primary SearchButton">Search</button>
		</div>
	</div>
</form>
